import * as React from 'react';

import type { WosIconProps } from 'types/common_types';

function signIn(props: WosIconProps) {
  const { className } = props;

  return (
    <svg xmlns="http://www.w3.org/2000/svg" className={className}>
      <g fill="#111111">
        <path
          fill="currentColor"
          d="M12,0C5.383,0,0,5.383,0,12s5.383,12,12,12s12-5.383,12-12S18.617,0,12,0z M18.698,19.404 C18.034,17.431,16.198,16,14,16h-4c-2.198,0-4.032,1.432-4.696,3.405C3.281,17.574,2,14.937,2,12C2,6.486,6.486,2,12,2 s10,4.486,10,10C22,14.936,20.72,17.573,18.698,19.404z"
        />{' '}
        <path
          data-color="color-2"
          d="M12,5C9.791,5,8,6.791,8,9v1c0,2.209,1.791,4,4,4s4-1.791,4-4V9C16,6.791,14.209,5,12,5z"
        />
      </g>
    </svg>
  );
}

export default signIn;
